import SurveyResults from "./SurveyResults";

export default SurveyResults;
